import React, { useState } from 'react';
import Button from "@mui/material/Button";
import { CircularProgress } from "@mui/material";
import AlertDialog from '../../../components/AlertDialog/index.es6';

const DisablePartnerUser = (props) => {
  if (!props.user) {
    return '';
  }

  const [showWarning, setShowWarning] = useState(false);

  const disableCurrentUser = () => {
    setShowWarning(true);
    props.disableUser(props.user);
  };

  const cancel = () => {
    props.resetUserToDisable();
  };

  const handleUserDisabledSuccessfully = () => {
    props.resetDisableUserSuccessAlert();
    props.resetUserToDisable();
  };

  const handleUserDisableError = () => {
    props.resetUserToDisable();
  };

  return (
    <>
      <AlertDialog
        custom
        show={props.showDisableUserProgressAlert}
        size="sm"
        style={{ marginTop: '0', top: '30vh' }}
        confirmBtnText={'ok'}
        showCancel={false}
        showConfirm={false}
        cancelBtnText={'cancel'}
        showTitle={false}
        confirmBtnCssClass
      >
        <CircularProgress />
        <h2>Disabling User</h2>
      </AlertDialog>

      <AlertDialog
        warning
        show={!showWarning && props.user}
        size="sm"
        title={'Are you sure you want to disable ' + props.user.firstName + '?'}
        style={{ marginTop: '0', top: '30vh' }}
        onConfirm={() => { cancel(); }}
        onCancel={() => { disableCurrentUser(); }}
        confirmBtnText={'Cancel'}
        showCancel={true}
        showConfirm={true}
        cancelBtnText={'Disable'}
        confirmBtnCssClass
      >
      </AlertDialog>

      <AlertDialog
        success
        show={props.showDisableUserSuccessAlert}
        size="sm"
        title={'User disabled successfully'}
        style={{ marginTop: '0', top: '30vh' }}
        onConfirm={() => { handleUserDisabledSuccessfully(); }}
        confirmBtnText={'Ok'}
        showCancel={false}
        showConfirm={false}
        cancelBtnText={'cancel'}
        confirmBtnCssClass
      >
        <div>
          <Button variant="contained" onClick={() => { handleUserDisabledSuccessfully(); }} style={{ background: 'green' }}>Ok</Button>
        </div>
      </AlertDialog>

      <AlertDialog
        show={props.showDisableUserErrorAlert}
        danger
        title={'Error disabling user'}
        onConfirm={() => handleUserDisableError()}
        confirmBtnText={'Try again'}
        confirmBtnCssClass
        showCancel={false}
        style={{ marginTop: '0', top: '30vh' }}
      >
        {'Could not disable user'}
      </AlertDialog>
    </>
  );
};

export default DisablePartnerUser;
